module.exports = __webpack_public_path__ + "static/media/rosemary.0085fe70.webp";